import { POSITION } from "@voltmoney/types";
import { ROUTE } from "../../../routes";
import { isFromAndroidWebview, isFromTDLPlatform, isMorePortfolioRenderCheck } from "../../../configs/utils";
import { ACTION } from "../unlock_limit/types";
import SharedPropsService from "../../../SharedPropsService";
import { AssetRepositoryType, ConfigTokens, getAppHeader } from "../../../configs/config";
import { LottieSizeTokens, LottieTokens, WIDGET } from "@voltmoney/schema";
import { api } from "../../../configs/api";
import AsyncStorage from "@react-native-async-storage/async-storage";
let isLottieShown = false;
export const continueLimit = async (action, _datastore, { navigate }) => {
    /*
    const routeObj = await nextStepId(ROUTE.MF_PLEDGE_PORTFOLIO);
    await navigate(routeObj.routeId, routeObj.params);
    */
    await navigate(ROUTE.MF_PLEDGE_PORTFOLIO);
};
export const modifyLimit = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.MODIFY_LIMIT, {
        stepResponseObject: action.payload.value,
    });
};
export const getMoreMfPortfolio = async (action, _datastore, { instrumentTrack, navigate, navigateWithClear, ...props }) => {
    /*** check if the user has pledged any mf portfolio */
    const assetRepoMap = new Map();
    /*** Get unique asset repository from the cas list */
    for (let i = 0; i < action.payload.casList.length; i++) {
        const item = action.payload.casList[i];
        assetRepoMap.set(item.assetRepository, true);
    }
    /*** Change page view type LAYOUT.LIST to LAYOUT.MODAL */
    await SharedPropsService.setConfig(ConfigTokens.IS_MF_FETCH_BACK_ALLOWED, true);
    /*** choosing default assetRepositoryType and then validating if switch is required */
    let assetRepoType;
    if (!assetRepoMap.has(AssetRepositoryType.KARVY)) {
        assetRepoType = AssetRepositoryType.KARVY;
    }
    else {
        assetRepoType = AssetRepositoryType.CAMS;
    }
    instrumentTrack("GET_MORE_PORTFOLIO_BUTTON_CLICKED", {
        "get_folio_from": assetRepoType,
        "page": ROUTE.UNLOCK_LIMIT_LANDING
    });
    /*** disable pan edit option */
    await SharedPropsService.setConfig(ConfigTokens.IS_PAN_EDIT_ALLOWED, false);
    await SharedPropsService.setConfig(ConfigTokens.IS_RTA_SWITCH_ENABLED, false);
    /*** Enable auto otp trigger when user lands on MF_Fetch */
    await SharedPropsService.setConfig(ConfigTokens.IS_MF_FETCH_AUTO_TRIGGER_OTP, true);
    /*** Go to re-fetch portfolio from other Asset Type **/
    navigate(ROUTE.MF_FETCH_PORTFOLIO, {
        setIsUserLoggedIn: true,
        assetRepository: assetRepoType,
    });
    /*** remove fetch more asset type option from UI */
    await removeGetMorePortfolio({
        type: ACTION.REMOVE_GET_MORE_MF_PORTFOLIO,
        routeId: ROUTE.UNLOCK_LIMIT_LANDING,
        payload: {},
    }, {}, { instrumentTrack, navigate, navigateWithClear, ...props });
};
export const removeGetMorePortfolio = async (action, _datastore, { removeWidgets }) => {
    if (!(await isMorePortfolioRenderCheck())) {
        await removeWidgets(ROUTE.UNLOCK_LIMIT_LANDING, [
            { id: "otherSourceStack", type: WIDGET.STACK },
        ]);
    }
};
export const goHome = async (action, _datastore, { navigate, network }) => {
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const applicationState = userContextResponse.data.linkedApplications[0].applicationState;
    await SharedPropsService.setApplicationState(applicationState);
    if (await AsyncStorage.getItem("application_id") !== null && !(await SharedPropsService.getElevateFlow())) {
        await navigate(ROUTE.MANAGE_LIMIT_LANDING);
    }
    else {
        if (applicationState === "COMPLETED") {
            await navigate(ROUTE.DASHBOARD);
        }
        else {
            if (await SharedPropsService.showHome()) {
                await navigate(ROUTE.BORROWER_LANDING_SCREEN);
            }
            else {
                if (isFromAndroidWebview() && isFromTDLPlatform()) {
                    window.open("closeActivity", "_parent");
                }
                window.parent.postMessage("Exit callback", "*");
                // @ts-ignore
                window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("closeActivity");
            }
        }
    }
};
export const onLoad = async (action, _datastore, { removeWidgets, appendWidgets }) => {
    if (!isLottieShown) {
        await appendWidgets(ROUTE.UNLOCK_LIMIT_LANDING, {
            lottie: {
                uri: LottieTokens.UnlockNew,
                autoplay: true,
                loop: false,
                size: LottieSizeTokens.FULL,
            },
        }, [
            { id: "lottie", type: WIDGET.LOTTIE, position: POSITION.ABSOLUTE_CENTER }
        ], "customHeader");
        isLottieShown = true;
    }
    if (!(await isMorePortfolioRenderCheck())) {
        await removeWidgets(ROUTE.UNLOCK_LIMIT_LANDING, [
            { id: "otherSourceStack", type: WIDGET.STACK },
        ]);
    }
    setTimeout(() => {
        removeWidgets(ROUTE.UNLOCK_LIMIT_LANDING, [
            { id: "lottie", type: WIDGET.LOTTIE },
        ]);
    }, 2000);
};
